import { Routes } from '@angular/router';
import { ConfirmEmailComponent } from './page/confirm-email/confirm-email.component';
import { AppUrl } from './appUrl';
import { VerifyEmailComponent } from './page/verify-email/verify-email.component';
import { ListRoomComponent } from './page/list-room/list-room.component';
import { CheckinComponent } from './page/checkin/checkin.component';
import { CustomerInfoComponent } from './page/customer-info/customer-info.component';
import { BookingInfoComponent } from './page/booking-info/booking-info.component';
import { BookingSuccessComponent } from './page/booking-success/booking-success.component';
import { PaymentComponent } from './page/payment/payment.component';
import { UploadPaymentComponent } from './page/upload-payment/upload-payment.component';
import { SelectGuestRoomComponent } from './page/select-guest-room/select-guest-room.component';
import { RoomQuantityComponent } from './page/room-quantity/room-quantity.component';
import { ListLocation } from './page/list-location/list-location';
import { ProfileComponent } from './page/profile/profile.component';
import { NotFoundComponent } from './page/not-found/not-found.component';

export const routes: Routes = [
    { path: '', redirectTo: '**', pathMatch: 'full', },
    { path: `${AppUrl.signin}/:app-id`, component: ConfirmEmailComponent },
    { path: `${AppUrl.verify}/:app-id`, component: VerifyEmailComponent },
    {
        path: `${AppUrl.list_room}`, children: [
            { path: `:app-id`, component: ListRoomComponent },
            { path: `:app-id/:branch-id`, component: ListRoomComponent }
        ]
    },
    { path: `${AppUrl.checkin}/:app-id`, component: CheckinComponent },
    { path: `${AppUrl.customer_info}/:app-id`, component: CustomerInfoComponent },
    { path: `${AppUrl.bookign_info}/:app-id`, component: BookingInfoComponent },
    { path: `${AppUrl.booking_success}/:app-id`, component: BookingSuccessComponent },
    { path: `${AppUrl.payment}/:app-id`, component: PaymentComponent },
    { path: `${AppUrl.upload_payment}/:app-id`, component: UploadPaymentComponent },
    { path: `${AppUrl.guest_room}/:app-id`, component: SelectGuestRoomComponent },
    { path: `${AppUrl.room_quantity}/:app-id`, component: RoomQuantityComponent },
    // { path: `${AppUrl.list_location}/:app-id`, component: ListLocation },
    {
        path: `${AppUrl.list_location}`, children: [
            { path: `:app-id`, component: ListLocation },
            { path: `:app-id/:branch-id`, component: ListLocation }
        ]
    },
    { path: `${AppUrl.profile}/:app-id`, component: ProfileComponent },
    { path: '**', component: NotFoundComponent },
];
